var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#74acdf",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 13.3h53.4v13.4H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m26.7 20.1 2.3 5h.1l-1.8-5.2m-.1 2c0 .7.4 1 .4 1.8q.1.9.4 1.3v.4l.1-.5c0-.4-.3-.5-.2-1.3s-.4-1-.3-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m26.7 20.1 2.3 5h.1l-1.8-5.2m-.1 2c0 .7.4 1 .4 1.8q.1.9.4 1.3v.4l.1-.5c0-.4-.3-.5-.2-1.3s-.4-1-.3-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m26.7 20 .2 5.5h.1l.3-5.5m-.8 1.8c-.3.6 0 1.2-.4 1.8-.3.6 0 1.1-.1 1.4l-.2.4q.1.1.4-.4-.1-.4.2-1.3c.4-.8.1-1.1.5-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m26.7 20 .2 5.5h.1l.3-5.5m-.8 1.8c-.3.6 0 1.2-.4 1.8-.3.6 0 1.1-.1 1.4l-.2.4q.1.1.4-.4-.1-.4.2-1.3c.4-.8.1-1.1.5-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "M26.7 19.9 25 25v.1l2.4-5M26 21.4c-.6.5-.6 1.2-1 1.6q-.7.8-.7 1.2l-.4.3q.1.1.5-.2c.3-.3.1-.6.8-1.1.6-.6.5-1 1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "M26.7 19.9 25 25v.1l2.4-5M26 21.4c-.6.5-.6 1.2-1 1.6q-.7.8-.7 1.2l-.4.3q.1.1.5-.2c.3-.3.1-.6.8-1.1.6-.6.5-1 1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m26.8 19.8-3.7 4v.1h.1l4-3.7m-1.8.7-1.6 1q-.7.5-1 1h-.5q0 .3.6 0c.3-.2.3-.5 1.1-.7.8-.3.8-.7 1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m26.8 19.8-3.7 4v.1h.1l4-3.7m-1.8.7-1.6 1q-.7.5-1 1h-.5q0 .3.6 0c.3-.2.3-.5 1.1-.7.8-.3.8-.7 1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M27.3 22c0 .7.5 1 .4 1.7.2-.6-.2-1-.2-1.7m-.6-2 1.5 3.5-1.3-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M26.6 22c-.3.6 0 1-.3 1.7.3-.5 0-1 .4-1.7m.2-2 .1 3.7.1-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M25.9 21.6c-.5.6-.5 1-1 1.5.5-.3.5-.8 1-1.4m1-1.8-1.3 3.6L27 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M25.3 21q-.7.7-1.4 1 .6-.2 1.5-.8m1.5-1.3-2.6 2.7 2.8-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m26.9 19.7-5 2.3v.1l5.2-1.8m-2-.1c-.7 0-1 .4-1.8.4q-.9.1-1.3.4h-.4l.5.1c.4 0 .5-.3 1.3-.2s1-.4 1.8-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m26.9 19.7-5 2.3v.1l5.2-1.8m-2-.1c-.7 0-1 .4-1.8.4q-.9.1-1.3.4h-.4l.5.1c.4 0 .5-.3 1.3-.2s1-.4 1.8-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m27 19.7-5.5.2v.1l5.5.3m-1.8-.8c-.6-.3-1.2 0-1.8-.4-.6-.3-1.1 0-1.4-.1l-.4-.2q-.1.1.4.4.4-.1 1.3.2c.8.4 1.1.1 1.8.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m27 19.7-5.5.2v.1l5.5.3m-1.8-.8c-.6-.3-1.2 0-1.8-.4-.6-.3-1.1 0-1.4-.1l-.4-.2q-.1.1.4.4.4-.1 1.3.2c.8.4 1.1.1 1.8.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "M27.1 19.7 22 18h-.1l5 2.4M25.6 19c-.5-.6-1.2-.6-1.6-1q-.7-.7-1.2-.7l-.3-.4q-.1.1.2.5c.3.3.6.1 1.1.8.6.6 1 .5 1.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "M27.1 19.7 22 18h-.1l5 2.4M25.6 19c-.5-.6-1.2-.6-1.6-1q-.7-.7-1.2-.7l-.3-.4q-.1.1.2.5c.3.3.6.1 1.1.8.6.6 1 .5 1.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m27.2 19.8-4-3.7H23v.1l3.7 4m-.7-1.8-1-1.6q-.5-.7-1-1v-.5q-.3 0 0 .6c.2.3.5.3.7 1.1.3.8.7.8 1 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m27.2 19.8-4-3.7H23v.1l3.7 4m-.7-1.8-1-1.6q-.5-.7-1-1v-.5q-.3 0 0 .6c.2.3.5.3.7 1.1.3.8.7.8 1 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M25 20.3c-.7 0-1 .5-1.7.4.6.2 1-.2 1.7-.2m2-.6-3.5 1.5 3.5-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M25 19.6c-.6-.3-1 0-1.7-.3.5.3 1 0 1.7.4m2 .2-3.7.1 3.7.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M25.4 18.9c-.6-.5-1-.5-1.5-1 .3.5.8.5 1.4 1m1.8 1-3.6-1.3L27 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M26 18.3q-.7-.7-1-1.4.2.6.8 1.5m1.3 1.5-2.7-2.6 2.5 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m27.3 19.9-2.3-5h-.1l1.8 5.2m.1-2c0-.7-.4-1-.4-1.8q-.1-.9-.4-1.3v-.4l-.1.5c0 .4.3.5.2 1.3s.4 1 .3 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m27.3 19.9-2.3-5h-.1l1.8 5.2m.1-2c0-.7-.4-1-.4-1.8q-.1-.9-.4-1.3v-.4l-.1.5c0 .4.3.5.2 1.3s.4 1 .3 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m27.3 20-.2-5.5H27l-.3 5.5m.8-1.8c.3-.6 0-1.2.4-1.8.3-.6 0-1.1.1-1.4l.2-.4q-.1-.1-.4.4.1.4-.2 1.3c-.4.8-.1 1.1-.5 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m27.3 20-.2-5.5H27l-.3 5.5m.8-1.8c.3-.6 0-1.2.4-1.8.3-.6 0-1.1.1-1.4l.2-.4q-.1-.1-.4.4.1.4-.2 1.3c-.4.8-.1 1.1-.5 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "M27.3 20.1 29 15v-.1l-2.4 5m1.4-1.3c.6-.5.6-1.2 1-1.6q.7-.7.7-1.2l.4-.3q-.1-.1-.5.2c-.3.3-.1.6-.8 1.1-.6.6-.5 1-1 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "M27.3 20.1 29 15v-.1l-2.4 5m1.4-1.3c.6-.5.6-1.2 1-1.6q.7-.7.7-1.2l.4-.3q-.1-.1-.5.2c-.3.3-.1.6-.8 1.1-.6.6-.5 1-1 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m27.2 20.2 3.7-4V16h-.1l-4 3.7m1.8-.7 1.6-1q.7-.5 1-1h.5q0-.3-.6 0c-.3.2-.3.5-1.1.7-.8.3-.8.7-1.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m27.2 20.2 3.7-4V16h-.1l-4 3.7m1.8-.7 1.6-1q.7-.5 1-1h.5q0-.3-.6 0c-.3.2-.3.5-1.1.7-.8.3-.8.7-1.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M26.7 18c0-.7-.5-1-.4-1.7-.2.6.2 1 .2 1.7m.6 2-1.5-3.5 1.3 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M27.4 18c.3-.6 0-1 .3-1.7-.3.5 0 1-.4 1.7m-.2 2-.1-3.7-.1 3.7m1.2-1.6c.5-.6.5-1 1-1.5-.5.3-.5.8-1 1.4M27 20l1.3-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M28.7 19q.7-.7 1.4-1-.6.2-1.5.8m-1.5 1.3 2.6-2.7-2.8 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m27.1 20.3 5-2.3v-.1l-5.2 1.8m2 .1c.7 0 1-.4 1.8-.4q.9-.1 1.3-.4h.4l-.5-.1c-.4 0-.5.3-1.3.2s-1 .4-1.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m27.1 20.3 5-2.3v-.1l-5.2 1.8m2 .1c.7 0 1-.4 1.8-.4q.9-.1 1.3-.4h.4l-.5-.1c-.4 0-.5.3-1.3.2s-1 .4-1.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m27 20.3 5.5-.2V20l-5.5-.3m1.8.8c.6.3 1.2 0 1.8.4.6.3 1.1 0 1.4.1l.4.2q.1-.1-.4-.4-.4.1-1.3-.2c-.8-.4-1.1-.1-1.8-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m27 20.3 5.5-.2V20l-5.5-.3m1.8.8c.6.3 1.2 0 1.8.4.6.3 1.1 0 1.4.1l.4.2q.1-.1-.4-.4-.4.1-1.3-.2c-.8-.4-1.1-.1-1.8-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "M26.9 20.3 32 22h.1l-5-2.4m1.3 1.4c.5.6 1.2.6 1.6 1q.8.7 1.2.7l.3.4q.1-.1-.2-.5c-.3-.3-.6-.1-1.1-.8-.6-.6-1-.5-1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "M26.9 20.3 32 22h.1l-5-2.4m1.3 1.4c.5.6 1.2.6 1.6 1q.8.7 1.2.7l.3.4q.1-.1-.2-.5c-.3-.3-.6-.1-1.1-.8-.6-.6-1-.5-1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    d: "m26.8 20.2 4 3.7h.1v-.1l-3.7-4m.7 1.8 1 1.6q.5.7 1 1v.5q.3 0 0-.6c-.2-.3-.5-.3-.7-1.1-.3-.8-.7-.8-1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85340a",
    strokeWidth: 0.1,
    d: "m26.8 20.2 4 3.7h.1v-.1l-3.7-4m.7 1.8 1 1.6q.5.7 1 1v.5q.3 0 0-.6c-.2-.3-.5-.3-.7-1.1-.3-.8-.7-.8-1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M29 19.7c.7 0 1-.5 1.7-.4-.6-.2-1 .2-1.7.2m-2 .6 3.5-1.5-3.5 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M29 20.4c.6.3 1 0 1.7.3-.5-.3-1 0-1.7-.4m-2-.2 3.7-.1-3.7-.1m1.6 1.2c.6.5 1 .5 1.5 1-.3-.5-.8-.5-1.4-1M27 20l3.6 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M28 21.7q.7.7 1 1.4-.2-.6-.8-1.5m-1.3-1.5 2.7 2.6-2.5-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b40e",
    stroke: "#85340a",
    strokeWidth: 0.2,
    d: "M27 22.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#843511",
    d: "m27.7 19.5-.3.2q.3.3.8 0zm0 0 .4.2q-.4.3-.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M27.8 19.4q-.3 0-.4.2h-.2.3zl.5.2-.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M28.4 19.5q-.7-.5-1.2-.1v.9q-.2-.3-.1-.8v-.1q.7-.6 1.3.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M27.7 19.8a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m.5 0q-.5.3-.8.1-.2-.1 0-.1zm-1.5.5v.3h.6l.2-.1-.1-.2v.1a.1.1 0 1 1-.2 0l-.2.2-.2-.2-.1.1h-.1zm.1.5-.4.2zh.6l.3.1-.4-.2h-.4m-.1.3h-.3 1zm-.3 0c.3 0 .1.3.5.3s.2-.2.6-.3c-.4 0-.3.2-.6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M27.3 21.6a.3.3 0 1 0-.6 0 .3.3 0 0 1 .6 0m-1.7-2.1q.8-.5 1.2-.1l.1.3-.2.6h.1q.2-.3.1-.8v-.1q-.7-.6-1.3.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M26.2 19.4q.4 0 .4.2h.2-.3zl-.5.2.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#843511",
    d: "m26.2 19.5-.4.2q.4.3.8 0zm0 0q.3 0 .3.2-.2.3-.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M26.2 19.8a.2.2 0 1 0 0-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M25.8 19.8q.5.3.8.1l.1-.1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.ef102d85b894b169f0b18b6e6f1300ad.svg";
export { ForwardRef as ReactComponent };